import { render, staticRenderFns } from "./MenuListPage.vue?vue&type=template&id=517730dc&"
import script from "./MenuListPage.vue?vue&type=script&lang=js&"
export * from "./MenuListPage.vue?vue&type=script&lang=js&"
import style0 from "./MenuListPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports